import type { Resource, CreateMigrationRequest, CreateMigrationResponse } from '../../types';
import { logger } from '../../utils/logger';
import { authenticatedFetch } from '../../utils/authenticatedFetch';
import { getV2AuthHeaders } from '../../utils/authHeaders';
import { getEnv } from '../../config/env';

const createMigration = async (
  bearerToken: string,
  request: CreateMigrationRequest
): Promise<CreateMigrationResponse> => {
  try {
    const baseUrl = getEnv().VITE_EDCI_API_URL;
    const url = `${baseUrl}/api/migrations/create`;

    const response = await authenticatedFetch(url, {
      method: 'POST',
      headers: {
        ...getV2AuthHeaders(bearerToken),
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(request)
    });

    if (!response.ok) {
      logger.error('Create migration API returned error', {
        status: response.status,
        statusText: response.statusText,
        url,
        resourceCount: request.resources?.length || 0
      });
      throw new Error(`Error creating migration: ${response.status} ${response.statusText}`);
    }

    const data: CreateMigrationResponse = await response.json();
    logger.info('Migration created successfully', {
      migrationId: data.id,
      resourceCount: request.resources?.length || 0,
      customerId: request.customerId,
      sourceOrgName: request.sourceOrgName,
      targetOrgName: request.targetOrgName
    });
    return data;
  } catch (error) {
    const msg = error instanceof Error ? error.message : String(error);
    logger.error('Failed to create migration', {
      error: msg,
      resourceCount: request.resources?.length || 0,
      customerId: request.customerId,
      sourceOrgName: request.sourceOrgName,
      targetOrgName: request.targetOrgName
    });
    throw error;
  }
};

export default createMigration;
export type { Resource };
